import { useViewer } from "~/auth/use-viewer"
import { formatDate } from "~/common/date"
import { experienceProfilePath, profileEditPath, securityPath } from "~/common/paths"
import { useDocumentTitle } from "~/common/use-document-title"
import { PageLayout } from "~/layouts/page-layout"
import { LinkButton } from "~/ui/link-button"
import { UserAvatar } from "~/users/user-avatar"

export const ProfileScreen = () => {
  useDocumentTitle("My account")
  const { viewer } = useViewer()

  return (
    <PageLayout
      title={viewer.fullName}
      actions={<LinkButton to={profileEditPath({})}>Edit Details</LinkButton>}
    >
      <div className="mb-6 flex flex-wrap gap-2">
        <LinkButton to={experienceProfilePath({})}>My experience & cadence</LinkButton>
        <LinkButton to={securityPath({})}>Sign-in & security</LinkButton>
      </div>
      <UserAvatar
        user={viewer}
        alt="A picture that represents you and your account"
        className="mb-8 h-16 w-16"
      />
      <table className="flex flex-wrap">
        <tbody>
          <tr>
            <td className="pr-10 text-gray-500">Date Created</td>
            <td>{formatDate(viewer.createdAt)}</td>
          </tr>
          <tr>
            <td className="pr-10 text-gray-500">Email Address</td>
            <td>{viewer.email}</td>
          </tr>
        </tbody>
      </table>
    </PageLayout>
  )
}
